export default "__VITE_ASSET__BUh766NK__"